import axios from "axios"

const axiosApiInstance = axios.create()
// Add base URL here.
const BASE_URL = process.env.REACT_APP_AUTH_BASE_URL
const BRANCH = process.env.REACT_APP_ENV_RESOURCE
let shouldDisableInterceptor = false
async function refreshAccessToken() {
  const refreshToken = JSON.parse(localStorage.getItem("refreshToken_" + BRANCH))

  try {
    const res = await axios.post(BASE_URL + "user/refresh-token", {
      refreshToken,
    })
    if (res.status === 200) {
      localStorage.setItem("accessToken_" + BRANCH, JSON.stringify(res.data.accessToken))
      return res.data.accessToken
    } else {
      // If refresh token is expired
      localStorage.clear()
      window.location.href = "/login"
      return null
    }
  } catch (RefreshErr) {
    // If refresh token is expired or invalid, clear storage and redirect
    localStorage.clear()
    window.location.href = "/login"
    return null
  }
}
// Interceptor that is called when a request is made.
axios.interceptors.request.use(
  async config => {
    if (!shouldDisableInterceptor) {
      let accessToken
      try {
        accessToken = JSON.parse(localStorage.getItem("accessToken_" + BRANCH))
      } catch (err) {
        // If there's an error parsing the token, redirect to login
        localStorage.clear()
        window.location.href = "/login"
        return Promise.reject(err)
      }

      // We want to make sure that the interceptor doesn't overwrite the Authorization header for the Digest Authentication
      // console.log("In config", config.url, config.url.includes("/axis-cgi"))
      if (config.url.includes("/axis-cgi") || config.url.includes("/carex-hanwha.mshome.net") || config.url.includes("ContinuousMovePtzCommand")) {
        return config
      }
      config.headers = {
        Authorization: `Bearer ${accessToken}`,
        "x-os": "Web",
      }
      return config
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)
// Interceptor that is called when a response is received.
axios.interceptors.response.use(
  (response) => {
    if (!shouldDisableInterceptor || response.config.url.includes("/axis-cgi") || response.config.url.includes("/carex-hanwha.mshome.net") || response.config.url.includes("ContinuousMovePtzCommand")) {
      return response
    }
    return response
  },
  async error => {
    try {
      const originalRequest = error.config

      if (originalRequest.url.includes("/axis-cgi") || originalRequest.url.includes("/carex-hanwha.mshome.net") || originalRequest.url.includes("ContinuousMovePtzCommand")) {
        return;
      }
      //Refresh token is expired. Logout the user.
      if (originalRequest.url.includes("/refresh-token")) {
        localStorage.clear()
        window.location.href = "/login"
        return Promise.reject(error)
      }
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        const newAccessToken = await refreshAccessToken()

        if (newAccessToken) {
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`
          return axiosApiInstance(originalRequest)
        } else {
          // If refresh failed, redirecting is handled in refreshAccessToken()
          return Promise.reject(error)
        }
      }
      return Promise.reject(error)

    } catch (err) {
      localStorage.clear()
      window.location.href = "/login"
      return Promise.reject(err)
    }
  }
)

export default axiosApiInstance
